export default "__VITE_ASSET__$_3RLfMf__"